import { render, staticRenderFns } from "./dettaglio-info-voli.vue?vue&type=template&id=d9f9e750&"
import script from "./dettaglio-info-voli.vue.ts?vue&type=script&lang=js&"
export * from "./dettaglio-info-voli.vue.ts?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports